<div class="container mx-auto px-4 py-6">
  <div class="mb-6">
    <h1 class="text-3xl font-bold text-gray-800">{{ id ? 'Editar Banner' : 'Novo Banner' }}</h1>
    <p class="text-gray-600 mt-2">Preencha os campos abaixo</p>
  </div>

  <div class="bg-white rounded-lg shadow p-6">
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div class="md:col-span-2">
        <label class="block text-sm font-medium text-gray-700 mb-1">Título *</label>
        <input [(ngModel)]="title" type="text" class="w-full px-3 py-2 border border-gray-300 rounded-md" placeholder="Ex: Promoção Verão">
      </div>
      <div class="md:col-span-2">
        <label class="block text-sm font-medium text-gray-700 mb-1">Descrição</label>
        <textarea [(ngModel)]="description" rows="3" class="w-full px-3 py-2 border border-gray-300 rounded-md" placeholder="Descrição do banner"></textarea>
      </div>
      <div class="md:col-span-2">
        <label class="block text-sm font-medium text-gray-700 mb-1">Imagem (URL) *</label>
        <input [(ngModel)]="imageUrl" type="url" class="w-full px-3 py-2 border border-gray-300 rounded-md" placeholder="https://...">
      </div>
      <div class="md:col-span-2">
        <label class="block text-sm font-medium text-gray-700 mb-1">Link de Destino</label>
        <input [(ngModel)]="linkUrl" type="url" class="w-full px-3 py-2 border border-gray-300 rounded-md" placeholder="https://...">
      </div>
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Ativo</label>
        <select [(ngModel)]="isActive" class="w-full px-3 py-2 border border-gray-300 rounded-md">
          <option [ngValue]="true">Ativo</option>
          <option [ngValue]="false">Inativo</option>
        </select>
      </div>
    </div>

    <div class="mt-6 flex gap-2">
      <button (click)="save()" [disabled]="saving" class="px-4 py-2 bg-primary text-white rounded-md">Salvar</button>
      <button (click)="cancel()" class="px-4 py-2 border rounded-md">Cancelar</button>
    </div>
  </div>
</div>
